import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { gridColumn } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import type { ColumnsType } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow } from 'modules/shift_management/lib/types'
import type DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

import BasicRow from './BasicRow'
import DailyRow from './DailyRow'
import WeeklyRow from './WeeklyRow'

interface Props {
  shiftsRow: ShiftsRow
  columns: ColumnsType
  visibleDefaultShifts: DefaultShifts
}
const ShiftsRowPerView = ({ shiftsRow, columns, visibleDefaultShifts }: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const [{ view }] = useSchedule()
  const hasBackupShifts = hasFeatureFlag('shift_management_backup_shifts')

  // Slice the first one which belongs to the employee/areas first cell
  const cells = useUnsafeMemo(() => columns.slice(1), [columns])

  if (view.isDaily)
    return (
      <Box style={{ ...gridColumn(1, columns.length) }}>
        <DailyRow
          shiftsRow={shiftsRow}
          columns={cells}
          visibleDefaultShifts={visibleDefaultShifts}
        />
      </Box>
    )

  if (view.isWeekly && hasBackupShifts && !view.isByAreas)
    return (
      <Box style={{ ...gridColumn(1, columns.length) }}>
        <WeeklyRow
          shiftsRow={shiftsRow}
          columns={cells}
          visibleDefaultShifts={visibleDefaultShifts}
        />
      </Box>
    )

  return (
    <BasicRow shiftsRow={shiftsRow} columns={cells} visibleDefaultShifts={visibleDefaultShifts} />
  )
}

export default observer(ShiftsRowPerView)
